import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  h1 {
    font-size: 22px;
    margin: 0;
  }
`;

export const Grid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${({ cols }) => cols}, minmax(0, 1fr));
  gap: 12px;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const KpiCard = styled.div<{ accent: string }>`
  background: #fff;
  border-radius: 8px;
  padding: 14px;
  border-top: 3px solid ${({ accent }) => accent};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  strong {
    display: block;
    font-size: 24px;
  }
  span {
    color: #8c8c8c;
    font-size: 12px;
  }
`;

export const Panel = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  h3 {
    font-size: 14px;
    margin: 0 0 8px;
  }
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  label {
    font-size: 12px;
    color: #8c8c8c;
    margin-bottom: 2px;
  }
`;
